export const ATTACK_TYPES = {
  CONVERSATION_HIJACKING: 'conversation_hijacking',
  EXTORTION: 'extortion',
  IMPERSONATION: 'impersonation',
  PHISHING: 'phishing',
  SCAMMING: 'scamming'
}

export const ETS_ATTACK_TYPES = {
  CONVERSATION_HIJACKING: 'conversation_hijacking',
  EXTORTION: 'extortion',
  IMPERSONATION: 'impersonation',
  // TODO: BNFIR-4234: may need to remove this depending on what happens with the results of the investigation.
  IMPERSONATION_BEC: 'impersonation_bec',
  // END TODO
  PHISHING: 'phishing',
  SCAMMING: 'scamming_graymail'
}

export const ATTACK_TYPES_BACKEND_KEYWORDS = {
  [ATTACK_TYPES.CONVERSATION_HIJACKING]: ['conversationHijacking'],
  [ATTACK_TYPES.EXTORTION]: ['blackmail'],
  [ATTACK_TYPES.IMPERSONATION]: ['becSpoofing'],
  // TODO: BNFIR-4234: may need to remove this depending on what happens with the results of the investigation.
  [ETS_ATTACK_TYPES.IMPERSONATION_BEC]: ['becSpoofing'],
  // END TODO
  [ATTACK_TYPES.PHISHING]: ['phishing'],
  [ATTACK_TYPES.SCAMMING]: ['spam'],
  [ETS_ATTACK_TYPES.SCAMMING]: ['spam']
}

/**
 * Validates the given attack type against a predefined set of backend keywords.
 *
 * @param type - The attack type to validate.
 * @returns The validated attack type if it exists in the backend keywords, otherwise `undefined`.
 */
export default function attackTypeValidator(type: string): string | undefined {
  const validatedAttackType: string | undefined = Object.keys(
    ATTACK_TYPES_BACKEND_KEYWORDS
  ).find((attackType: string) => ATTACK_TYPES_BACKEND_KEYWORDS[attackType].includes(type))

  return validatedAttackType
}
